import { useQuery } from "@tanstack/react-query";
import { queueApi } from "@bw/shared/api";
import type { PartyMembershipRecoveryResponse } from "@bw/shared/types/generated";
import { queryKeys } from "../../../common/query/queryClient";

/** Canonical plural inventory used to detect and recover orphan memberships. */
export function usePartyMemberships(
  facilityId: string,
  options: { enabled?: boolean } = {},
) {
  return useQuery<PartyMembershipRecoveryResponse[]>({
    queryKey: queryKeys.dropin.partyMemberships(facilityId),
    queryFn: () => queueApi.listPartyMemberships(facilityId),
    enabled: Boolean(facilityId) && (options.enabled ?? true),
    retry: false,
    refetchOnMount: "always",
    refetchOnWindowFocus: "always",
    refetchOnReconnect: "always",
  });
}
